import React, { useState } from 'react';
import Button from '../atoms/Button';
import Typography from '../atoms/Typography';
import './TechStackInput.css';

const TechStackInput = ({ onTextSubmitted }) => {
  const [techText, setTechText] = useState('');
  const [error, setError] = useState(null);

  const handleSubmit = () => {
    if (!techText.trim()) {
      setError('Please enter technical requirements or job description');
      return;
    }

    if (techText.trim().length < 20) {
      setError('Please provide more detailed technical requirements (at least 20 characters)');
      return;
    }

    setError(null);
    onTextSubmitted(techText.trim());
  };

  const handleTextChange = (e) => {
    setTechText(e.target.value);
    if (error) {
      setError(null);
    }
  };

  // Updated example technologies with specific stacks
  const exampleStacks = [
    {
      label: "React Developer",
      stack: "React, TypeScript, Redux Toolkit, React Query, Jest, Webpack, Material-UI, REST APIs, Git, Agile methodologies",
      className: "react"
    },
    {
      label: "Node.js Developer", 
      stack: "Node.js, Express.js, MongoDB, PostgreSQL, Redis, Docker, AWS, GraphQL, JWT, Microservices, Socket.io, TypeScript",
      className: "nodejs"
    },
    {
      label: ".NET Developer",
      stack: ".NET Core, C#, Entity Framework, SQL Server, Azure, ASP.NET MVC, Web API, SignalR, Docker, Kubernetes, CI/CD",
      className: "dotnet"
    },
    {
      label: "Full-Stack Engineer",
      stack: "React, Node.js, PostgreSQL, TypeScript, AWS, Docker, GraphQL, Jest, CI/CD, Microservices, Redis, Kubernetes",
      className: "fullstack"
    }
  ];

  const handleTagClick = (stack) => {
    setTechText(stack);
    if (error) {
      setError(null);
    }
  };

  return (
    <div className="tech-stack-input">
      <div className="input-section">
        <Typography variant="h3" className="input-label">
          Technical Requirements
        </Typography>
        <Typography variant="body2" className="input-description">
          Enter the job description, required tech stack, or specific technologies you want to be interviewed about:
        </Typography>
        
        {/* Move examples above the textarea */}
        <div className="examples-section">
          <Typography variant="body2" className="examples-title">
            Quick Start Templates:
          </Typography>
          <div className="examples-tags">
            {exampleStacks.map((example, index) => (
              <button
                key={index} 
                className={`example-tag ${example.className}`}
                onClick={() => handleTagClick(example.stack)}
              >
                {example.label}
              </button>
            ))}
          </div>
        </div>
        
        <textarea
          value={techText}
          onChange={handleTextChange}
          placeholder="e.g., React, Node.js, PostgreSQL, AWS, Docker, GraphQL..."
          className="tech-textarea"
          rows={6}
        />
        
        {error && (
          <Typography variant="body2" color="error" className="error-message">
            {error}
          </Typography>
        )}
        
        <Button
          onClick={handleSubmit}
          variant="secondary"
          size="medium"
          className="submit-button"
          disabled={!techText.trim()}
        >
          Set Technical Requirements
        </Button>
      </div>
    </div>
  );
};

export default TechStackInput; 